import http from "@/services/http"

export function getForAssignment(organizationsGroupId, year, subOperationId) {
  return http.get(`cars/organizations-group/${organizationsGroupId}/work?subOperationId=${subOperationId}&year=${year}`)
}

export function getHelpCars(orgId, from, till) {
  return http.get(`cars/organizations/${orgId}/help?from=${from}&to=${till}`)
}

export function copy(organizationId, year, body) {
  return http.post(`cars/${organizationId}/copyPrevYearTo/${year}`, body)
}

export function getCar(carId, year) {
  return http.get(`car-passport?carId=${carId}&year=${year}`)
}

export function postHelpCarsLastLocations(ids) {
  return http.post(`gps-data/last-locations`, {carIds: ids})
}

export function getCarLastLocations(orgId) {
  return http.get(`CarLastLocations/${orgId}`)
}
export function getCarsStatusReport({organizationId, year}) {
  return http.downloadXLS(`cars/status/excel?organizationId=${organizationId}&year=${year}`, {}, "Статус техники")
}

export default {
  copy,
  getHelpCars,
  postHelpCarsLastLocations
}
